import { AppointmentReason } from 'models/Appointment';

const DEFAULT_CATEGORY = 'Meeting';

const FIXED_JOB_CATEGORIES: Partial<Record<AppointmentReason, string>> = {
  [AppointmentReason.AdhocMentoring]: 'Mentoring',
  [AppointmentReason.BelongingNetwork]: 'Virtual Meeting',
  [AppointmentReason.DevelopmentDays]: 'Virtual Meeting',
  [AppointmentReason.DrugAndAlcoholTest]: 'Meeting',
  [AppointmentReason.EmpoweredPeople]: 'Virtual Meeting',
  [AppointmentReason.Meeting]: 'Virtual Meeting',
  [AppointmentReason.MobilisationTravel]: 'Travel',
  [AppointmentReason.MyProgressMeeting]: 'Virtual Meeting',
  [AppointmentReason.OVOProjectSupport]: 'Virtual Meeting',
  [AppointmentReason.PersonalAppointment]: 'Appointment',
  [AppointmentReason.RoutineMentoring]: 'Mentoring',
  [AppointmentReason.TradeUnionAdhoc]: 'Virtual Meeting',
  [AppointmentReason.TradeUnionRegularMeeting]: 'Virtual Meeting',
  [AppointmentReason.Training]: 'Virtual Meeting',
  [AppointmentReason.Travel]: 'Travel',
  [AppointmentReason.VehiclePlannedMaintenance]: 'Vehicle',
  [AppointmentReason.VehicleUnplannedMaintenance]: 'Vehicle',
  [AppointmentReason.VehicleSwap]: 'Vehicle'
};

export const getFixedJobCategory = (
  reason: string | null | undefined
): string => {
  return FIXED_JOB_CATEGORIES[reason as AppointmentReason] ?? DEFAULT_CATEGORY;
};
